import Box from "./Box";
import ChevronIcon from "../assets/chevron.svg";
import PropTypes from "prop-types";
import SmallCaps from "./SmallCaps";
import { useHovered } from "../core/hooks";
import { useRef } from "react";

function SizeAndFit({ href }) {
  const ref = useRef(null);
  const hovered = useHovered(ref);

  return (
    <Box
      borderBottom="1px solid black"
      borderTop="1px solid black"
      py={[20, null, 30, null]}
    >
      <a href={href} target="_blank">
        <Box
          ref={ref}
          display="inline-flex"
          alignItems="center"
          opacity={hovered ? 0.5 : 1}
          transition="opacity 200ms"
        >
          <SmallCaps>Size & fit</SmallCaps>
          <Box
            pr={10}
            transition="transform 200ms ease-out"
            transform={
              hovered
                ? "rotate(180deg) translate3d(-3px, 0, 0)"
                : "rotate(180deg)"
            }
          >
            <ChevronIcon aria-label="Arrow" />
          </Box>
        </Box>
      </a>
    </Box>
  );
}

SizeAndFit.propTypes = {
  href: PropTypes.string.isRequired,
};

export default SizeAndFit;
